import React, { useState } from "react";
import { FluentDatePicker } from "../FluentUI/Fluent-DatePicker";
import { FluentCalendarDrilldown } from "../FluentUI/Fluent-Calendar-Drilldown";

import "./date-range-picker.scss";

const DateRangePicker = ({ start, setStart, end, setEnd }) => {
  const [selectionComplete, toggleSelectionComplete] = useState(
    Boolean(start) && Boolean(end)
  );

  const handleDateChange = (date) => {
    if (!selectionComplete && !start) {
      setStart(date);
    } else if (!selectionComplete && start && !end) {
      if (date < start) {
        setStart(date);
      } else {
        setEnd(date);
        toggleSelectionComplete(true);
      }
    } else if (selectionComplete && start && end) {
      setStart(date);
      setEnd(undefined);
      toggleSelectionComplete(false);
    }
  };

  return (
    <div className="custom-date-range-picker">
      <div className="calendar-first-row">
        <div>
          <p className="calendar-title">Start Date:</p>
          <FluentDatePicker
            className="calendar-text-box"
            value={start}
            onChange={(date) => setStart(date)}
            placeholder="MM/DD/YYYY"
            disabled
          />
        </div>

        <div>
          <p className="calendar-title">End Date:</p>
          <FluentDatePicker
            className="calendar-text-box"
            value={end}
            onChange={(date) => setEnd(date)}
            placeholder="MM/DD/YYYY"
            disabled
          />
        </div>
      </div>

      <div className="calendar-second-row">
        <FluentCalendarDrilldown
          value={end ?? start ?? undefined}
          onSelectDate={handleDateChange}
          maxDate={new Date()}
          isMonthPickerVisible
          showMonthPickerAsOverlay
        />
      </div>

      <div className="calendar-bottombar">
        <button
          className="calendar-clear-button"
          onClick={() => {
            setStart(undefined);
            setEnd(undefined);
            toggleSelectionComplete(false);
          }}
        >
          Clear
        </button>
      </div>
    </div>
  );
};

export default DateRangePicker;
